import React from "react";

import { CrossIcon } from "../../../../resource/icons";

import "./FiltrationTag.scss";

const FiltrationTag = ({
	type,
	className,
	inAddress,
	onDelete,
	onAdd,
	active,
}) => {
	if (!type) {
		return null;
	}
	
	return (
		<div
			key={type.id}
			className={className}
			onClick={() => {
				if (!inAddress) {
					if (active) {
						onDelete();
					} else {
						onAdd();
					}
				}
			}}
		>
			{type.name}
			{inAddress && <CrossIcon onClick={onDelete} className="delete-icon" />}
		</div>
	);
};

export default FiltrationTag;
